module.exports = __webpack_public_path__ + "static/fonts/Oswald-Heavy.85170ba.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-Heavy.ttf
// module id = MyOj
// module chunks = 1